/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowFigureASquareDownIcon20Solid = forwardRef('ArrowFigureASquareDownIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M18 6a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v8a4 4 0 0 0 4 4h8a4 4 0 0 0 4-4V6Zm-4.293 4.251a.9.9 0 0 0-1.271.062L10.9 12.006V6a.9.9 0 1 0-1.8 0v6.006l-1.536-1.693a.9.9 0 0 0-1.333 1.21l2.362 2.602a1.9 1.9 0 0 0 2.814 0l2.362-2.602a.9.9 0 0 0-.062-1.272Z" })));
});
